<template>
  <div class="bg-gray-100 px-4 pb-4 pt-0.5 rounded-xl shadow">
    <NewsletterSubscribe />
  </div>
  <!-- <form ref="form" class="w-full md:max-w-4/6" submit.prevent="subscribeEmail">
          <p class="mt-4 text-md font-medium">Subscribe to our newsletter</p>
          <ul class="flex gap-x-4 !list-none text-xs text-gray-500 !pt-2 ">
            <li class="pl-0.5">New Models</li>
            <li class="pl-0.5">Exclusive Offers</li>
            <li class="pl-0.5">Promotions</li>
          </ul>
          <div class="mt-2 -ml-1 text-gray-500 bg-white rounded-full overflow-hidden shadow text-sm flex gap-x-2">
            <input name="email" type="email" class="outline-none px-4 w-full" required placeholder="Enter your email">
            <button type="submit"
            class="block max-w-max text-center cursor-pointer rounded-full px-4 py-2.5 disabled:cursor-not-allowed disabled:bg-gray-200  bg-accent text-white">Subscribe</button>
          </div>
        </form> -->
  <!-- <div class="cta-news rounded-md shadow bg-primary text-white text-center">
    <p>
      <translate>Sign up for our newsletter</translate>
    </p>
    <ul>
      <li>
        <translate>New models</translate>
      </li>
      <li>
        <translate>Exclusive offers</translate>
      </li>
      <li>
        <translate>Promotions</translate>
      </li>
    </ul>
    <div class="inline-button">
      <input v-model="email" placeholder="Enter your email"/>
      <button @click="postEmail()" class="btn-news" :disabled="!email || loading" variant="primary" squared size="sm">
        {{buttonMessage }}
      </button>
    </div>
    <p v-if="thanking" class="thanks">
      Thanks for Signing up to our newsletter!
    </p>
  </div> -->
</template>

<script>
export default {
  name: "newsletter-inline",
  props: ["blok"],
  computed: {
    buttonMessage() {
      if (this.loading) {
        return "...";
      }
      return this.blok.message || "Signup";
    },
  },
  data() {
    return {
      loading: false,
      email: "",
      thanking: false,
    };
  },
  methods: {
    subscribed() {
      this.loading = false;
      this.email = "";
      this.thanking = true;
      setTimeout(() => {
        this.thanking = false;
      }, 2000);
    },
    async postEmail() {
      this.loading = true;
      let hutk = document.cookie.replace(/(?:(?:^|.*;\s*)hubspotutk\s*=\s*([^;]*).*$)|^.*$/, "$1");
      let args = { email: this.email, first_name: "", last_name: "" };
      if (hutk) {
        args["hutk"] = hutk;
      }
      // this.$api.post("public_api/users/newsletter_signup/", args).then(this.subscribed);
    },
  },
};
</script>

<style scoped>
ul li::marker {
  content: "\2713";
  color: green;
}
</style>

<!-- <style scoped>
div.cta-news {
  padding: 1rem;
  margin-block: 1rem;
  margin-inline: auto;
  /* border-radius: 10px; */
  width: min(100% - 3rem, 500px);
  /* background-color: white; */
}

div.cta-news p:first-child {
  font-family: sans-serif;
}

div.cta-news ul li {
  padding-left: 4px;
}

div.cta-news ul {
  font-size: 13px;
  padding: 0;
  display: flex;
  gap: 1.2rem;
  list-style: none;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
}

div.cta-news ul li::marker {
  content: "\2713";
  color: green;
}


div.inline-button {
  overflow: hidden;
  position: relative;
  display: inline-block;
  border-radius: 5px;
  width: min(100% - 2rem, 380px)
}

div.inline-button button {
  width: 120px;
  height: 20px;
  border-radius: 10px !important;
  border: none;
  color: white;
  background: var(--crf-accent);
  display: block;
  margin: 1rem auto 0 auto;
  cursor: pointer;
}

@media screen and (min-width: 500px) {
  div.inline-button input[type=text] {
    position: relative;
    width: 100%;
    height: 36px;
    box-sizing: border-box;
    border: 2px solid var(--crf-accent);
    border-radius: 5px;
    font-size: 16px;
    background-color: white;
    padding: 2px 125px 2px 10px;
  }

  div.inline-button button {
    position: absolute;
    margin: 0;
    width: 120px;
    height: 100%;
    top: 0px;
    right: 0px;
    border: none;
    border-radius: 0 !important;
    color: white;
    background: var(--crf-accent);
    display: block;
    cursor: pointer;
  }

}

p.thanks {
  margin: 10px 0;
  font-size: 0.8rem;
}
</style> -->
